import React from "react";
import { Drawer } from "@design-system/Drawer/Drawer";
import { useDrawerContentMount } from "@design-system/Drawer/useDrawerContentMount";
import { DirectorySettings } from "./DirectorySettings";

interface Props {
    open: boolean;
    onClose: () => void;
}

export const CounterpartiesDrawer: React.FC<Props> = ({ open, onClose }) => {
    const { shouldRender, openKey, onAnimationEnd } =
        useDrawerContentMount(open);

    return (
        <Drawer
            open={open}
            onClose={onClose}
            direction="right"
            size="fullScreenWithNav"
            onAnimationEnd={onAnimationEnd}
            headerAddonLeft="Counterparties"
            noPadding
        >
            {shouldRender && <DirectorySettings key={openKey} />}
        </Drawer>
    );
};
